import { URI_MESSAGES_SERVICE } from '@/config/config';
export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const response = await fetch(
    `${URI_MESSAGES_SERVICE}users/close-help-request`,
    opts,
  );
  if (response.status >= 400) {
    const jsonResult = await response.json();
    throw new Error(jsonResult);
  }
};
